import { ConsumptionOmie, OmieWeekly, PriceOmie } from "@edp-models/consumptions-omie.model";

export interface IConsumptionOmieState {
    omieWeeklyAverage: OmieWeekly;
    consumptionOmie: ConsumptionOmie;
    omiePrice: PriceOmie;
}

export const initialOmieState: IConsumptionOmieState = {
    omieWeeklyAverage: null,
    consumptionOmie: null,
    omiePrice: null,
};
